import { cn } from "@/lib/cn";
import { forwardRef, type HTMLAttributes } from "react";

/** The one modal veil; no `backdrop-blur` (costly on the low-end phones the storefront targets). */
export const SCRIM = "bg-scrim/60";

/** Lightbox veil: near-opaque so the eye reads the enlarged photo, not the page behind it. */
export const LIGHTBOX_SCRIM = "bg-scrim/90";

/** Prize-game veil: the default veil with a 3px blur, the one blurred veil (a single short-lived sheet over the menu). */
export const GAME_SCRIM = "bg-scrim/60 backdrop-blur-game";

const SCRIM_TONE = { default: SCRIM, lightbox: LIGHTBOX_SCRIM, game: GAME_SCRIM } as const;

export type ScrimProps = HTMLAttributes<HTMLDivElement> & {
  /** Layer from `useModalLayer().backdropZIndex`. */
  zIndex?: number;
  tone?: keyof typeof SCRIM_TONE;
};

/** Fixed full-screen veil behind sheets and dialogs; opening two never darkens the screen in different steps. */
export const Scrim = forwardRef<HTMLDivElement, ScrimProps>(function Scrim(
  { className, style, zIndex, tone = "default", ...rest },
  ref,
) {
  return (
    <div
      {...rest}
      ref={ref}
      className={cn("fixed inset-0", SCRIM_TONE[tone], className)}
      style={zIndex === undefined ? style : { zIndex, ...style }}
    />
  );
});
